export const ROLES = {
    ADMIN: "admin",
    BOARD_ADMIN: "Board Admin",
    USER: "CAM",
};

export const ROLE_HIERARCHY = {
    [ROLES.ADMIN]: ["admin", "Board Admin", "User"],
    [ROLES.BOARD_ADMIN]: ["Board Admin"],
    [ROLES.USER]: ["CAM"],
};

export const PAGE_CODES = {
  ALL_AAT: "A11",
  HOME: "D1",
  ALL_ACCESS: "A1",
  ALL_ACCESS_USERS: "U1",
  RIC: "R1",
  FAQ: "F1",
  FINANCIAL_REVIEW_TASKS: "F2",
  BLU: "B1",
  MAT: "M1",
  CAM: "C2",
  CAT: "C1",
  TENANT_REGISTRATIONS: "T1",
  TENANT_REGISTRATIONS_SUBMISSIONS: "T11",
  TENANT_REGISTRATIONS_DISCLAIMERS: "T12",
  TENANT_REGISTRATIONS_FEES: "T13",
  SMS: "S1",
  VMS_INVOICE: "V1",
  VMS_INVOICE_UPLOAD: "V11",
  VMS_INVOICE_BATCHES: "V12",
  COMMUNITY_PERMISSIONS: "C12",
  SCHEDULE_MAINTENANCE: "M2",
};
